import React, { useState, useEffect, useRef } from "react";
import "./QuizplayTask.css";
import { FaTimes, FaCheck } from "react-icons/fa";
import useUserInfo from "../../../Hooks/useUserInfo";
import { format, startOfDay, differenceInCalendarDays } from "date-fns";
import logo from "../../../assets/images/coinlogo.png";
import { userGameRewards } from "../../../apis/user";
import quiz from "./QuizTask";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";
import { FunQuizQues } from "../../../helpers/helpers";

const questions = FunQuizQues;

const QuizPlayTask = () => {
  const { userDetails, updateUserInfo,updatewatchScreenInfo,watchScreen } = useUserInfo();
  const CurrentPhase = userDetails?.currentPhase -1;
  
  const userId = userDetails?.userDetails?.telegramId;
  const selectedDay = userDetails.selectedDay || 1;
  const currentCycle = userDetails.currentCycle || 1;
const IsPointsReached = watchScreen?.LoginMessage=="You have already reached the maximum rewards limit"?true:false
  const [currentQuestions, setCurrentQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [answered, setAnswered] = useState(false);
  const [quizComplete, setQuizComplete] = useState(false);
  const playClick = useAudio();

  const today = useRef(
    startOfDay(new Date(userDetails?.userDetails?.lastLogin))
  );
  const baseDate = useRef(startOfDay(new Date("2025-01-09")));

  const startDate = new Date("2025-01-09");
  const totalDays = 84; // Total days from startDate to endDate
  const daysInPhase = 7; // Number of days per phase
  const totalQuizzesPerDay = 5;
  const [quizProgress, setQuizProgress] = useState([]);

  // Function to simulate the current day based on the start date
  const calculateSimulatedDay = () => {
    const today = new Date(); // This will be used to simulate the current day
    const diffTime = Math.abs(today - startDate);
    const simulatedDay = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return simulatedDay > 0 ? simulatedDay : 1; // Ensure that Day 1 is correctly set
  };
  const simulatedDay = calculateSimulatedDay();
  const currentPhase = userDetails?.currentPhase;
  console.log(userDetails);
  useEffect(() => {
    logPageView("Quitzplay", "Quitzplay page");
  }, []);

  useEffect(() => {
    if (simulatedDay > totalDays) {
      setQuizProgress([]);
    } else {
      const progress = Array.from({ length: daysInPhase }, (_, i) => {
        const day = (currentPhase - 1) * daysInPhase + i + 1;
        const completedIndex =
          parseInt(localStorage.getItem(`quizIndex_day${day}_${userId}`)) || 0;
        const quizzesRemaining = totalQuizzesPerDay - completedIndex;
        if (day <= simulatedDay && quizzesRemaining > 0) {
          return ` Play Game ${quizzesRemaining}/5 `;
        } else if (completedIndex >= totalQuizzesPerDay) {
          return "Completed";
        } else {
          return "Locked";
        }
      });
      setQuizProgress(progress);
    }
  }, [currentPhase, simulatedDay]);

  useEffect(() => {
    const initializeQuiz = () => {
      const dayIndex = differenceInCalendarDays(
        today.current,
        baseDate.current
      );
      if (selectedDay > dayIndex + 1) {
        setQuizComplete(true);
        return;
      }
      const startIndex = (currentCycle - 1) * 35 + (selectedDay - 1) * 5;
      const storedResult = localStorage.getItem(
        `quizResult_Day_${selectedDay}_Cycle_${currentPhase}_${userId}`
      );
      var data = JSON.parse(storedResult);
      if (data?.remain === 0) {
        setQuizComplete(true);
      } else {
        setCurrentQuestions(
          questions.slice(
            CurrentPhase * 7 * 5 + startIndex,
            CurrentPhase * 7 * 5 + startIndex + 5
          )
        );
        setCurrentQuestionIndex(data?.remain ? 5 - data?.remain : 0);
        setSelectedOption(null);
        setAnswered(false);
        setScore(0);
        setQuizComplete(false);
      }
    };
    initializeQuiz();
  }, [selectedDay, currentCycle]);

  const [isLoading, setIsLoading] = useState(false); // State to manage loader visibility

  const handleAnswerOptionClick = async (option) => {
    playClick();
    if (!answered) {
      // Show loader
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      setIsLoading(true);
      try {
        const result = {
          date: format(today.current, "yyyy-MM-dd"),
          gamePoints: String(score),
          completed: 5 - (currentQuestionIndex + 1) === 0 ? true : false,
          remain: 5 - (currentQuestionIndex + 1),
        };

        localStorage.setItem(
          `quizResult_Day_${selectedDay}_Cycle_${currentPhase}_${userId}`,
          JSON.stringify(result)
        );

        setSelectedOption(option);

        const isCorrect =
          option === currentQuestions[currentQuestionIndex].answer;

        const pointsAwarded = isCorrect 
          ? (userDetails?.earlyUsersLimitReached ? 1000 : 1000)
          : (userDetails?.earlyUsersLimitReached ? 0 : 500);

        setScore((prevScore) => prevScore + pointsAwarded);

        const apiData = {
          gamePoints: String(pointsAwarded),
          gameType: "FunQuiz",
        };

        // API call
         const res = await userGameRewards(apiData);
          updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        await setAnswered(true);
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        // Hide loader
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        setIsLoading(false);
      }
    }
  };


  const handleNextQuestion = async () => {
    playClick();
    if (currentQuestionIndex + 1 < currentQuestions.length) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setSelectedOption(null);
      setAnswered(false);
    } else {
      if (IsPointsReached){
        setQuizComplete(true)
      }
      else {
      setShowScore(true);
      }
    

      const completedDays =
        JSON.parse(localStorage.getItem(`completedDays_${userId}`)) || [];
      if (!completedDays.includes(selectedDay)) {
        completedDays.push(selectedDay);
        localStorage.setItem(
          `completedDays_${userId}`,
          JSON.stringify(completedDays)
        );
      }
    }
  };

  const toogleMenu = () => {
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: quiz,
      currentComponentText: "quiz",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
    playClick();
  };

  return (
    <div className="quiz-play-task">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <h1 className="welcome-text">Quiz Game</h1>
      {quizComplete ? (
        <div className="cards">
          <h1 className="title-epic">Come back later!</h1>
          <p className="bottom-text">
            You've completed this day's quiz. Please return tomorrow to
            continue!
          </p>
        </div>
      ) : showScore ? (
        <div className="cards">
          <h1 className="title-epic">{score > 0 ? "Epic Win!" : "Better Luck Next Time!"}</h1>
          <div className="pointsContainer">
            <div className="pointsInnerContainer">
              <p className="pointsLabel">TOKENS EARNED </p>
              <div className="pointsValue">
                <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' alt="Points" />
                <p className="pointsNumber">{score}</p>
              </div>
            </div>
          </div>
          <p className="bottom-text">
            Play daily to boost your score <br /> and rack up more points!
          </p>
        </div>
      ) : (
        <>
          <div className="question-count">
            <span>
              {" "}
              YOU HAVE {currentQuestions.length - currentQuestionIndex}
            </span>
            /{currentQuestions.length} Question
          </div>
          <div className="question-section">
            <div className="question-text">
              {currentQuestions[currentQuestionIndex]?.question}
            </div>
            <div className="answer-section">
              {currentQuestions[currentQuestionIndex]?.options.map((option) => (
                <button
                  key={option}
                  onClick={() => handleAnswerOptionClick(option)}
                  style={{
                    backgroundColor:
                      answered && selectedOption === option
                        ? option ===
                          currentQuestions[currentQuestionIndex].answer
                          ? "green"
                          : "red"
                        : "initial",
                    color: "white",
                  }}
                  disabled={answered}
                >
                  {option}
                  {answered &&
                    selectedOption !== option &&
                    option ===
                      currentQuestions[currentQuestionIndex].answer && (
                      <FaCheck style={{ marginLeft: "10px", color: "white" }} />
                    )}
                  {answered &&
                    selectedOption === option &&
                    (option ===
                    currentQuestions[currentQuestionIndex].answer ? (
                      <FaCheck style={{ marginLeft: "10px", color: "white" }} />
                    ) : (
                      <FaTimes style={{ marginLeft: "10px", color: "white" }} />
                    ))}
                </button>
              ))}
            </div>
          </div>
          <button
            onClick={handleNextQuestion}
            disabled={!answered || isLoading}
            className="quitz-btn"
          >
            {"Next"}
          </button>
        </>
      )}
    </div>
  );
};

export default QuizPlayTask;
